import { ReactNode } from 'react';

interface AdminPageHeaderProps {
  actions?: ReactNode;
  eyebrow: string;
  description: string;
  title: string;
  total?: number;
}

export function AdminPageHeader({ actions, description, eyebrow, title, total }: AdminPageHeaderProps) {
  return (
    <header className="admin-page-header">
      <div className="admin-page-header__copy">
        <p className="admin-eyebrow">{eyebrow}</p>
        <div className="admin-page-header__title-row">
          <h1>{title}</h1>
          {total !== undefined ? <span className="admin-page-header__count">{total}</span> : null}
        </div>
        <p>{description}</p>
      </div>
      {actions !== undefined ? <div className="admin-page-header__actions">{actions}</div> : null}
    </header>
  );
}
